var ajax = require('@hb/hb-hdfajax/index.js');
function ajaxrecordlog(type,value) {
    ajax({
        url:"/napi/hdfcustomlog",
        data:{
            customLogType:type,
            customLogRecords:value
        },
        type:'post',
        isNotShowErrorAlert:true
    })
}
module.exports =  ajaxrecordlog;